import { isAbandonedDocument } from './knowledgePolling';

export type DocumentActionTarget = Readonly<{
  id: string;
  status?: string | null;
  sourceType?: string | null;
  abandoned?: boolean | null;
  fileName?: string | null;
  displayName?: string | null;
  mimeType?: string | null;
}>;

export function getDocumentLabel(document: DocumentActionTarget): string {
  return (
    document.fileName?.trim() || document.displayName?.trim() || document.id
  );
}

export function canRetryFailedUploadDocument(
  document: DocumentActionTarget,
): boolean {
  return document.status === 'FAILED' && document.sourceType === 'UPLOAD';
}

export function canResumeAbandonedDocument(
  document: DocumentActionTarget,
): boolean {
  return isAbandonedDocument(document);
}

export function allSelectedSupport(
  documents: readonly DocumentActionTarget[],
  predicate: (document: DocumentActionTarget) => boolean,
): boolean {
  return documents.length > 0 && documents.every(predicate);
}
